export const mobileProfileAction = (status) => ({
    type: 'MOBILE_PROFILE',
    status
});
